export enum SourceCode {
  GovernmentVerified = '1',
  UserProvided = '2',
  FieldIsNotApplicableToPerson = '3',
  VerifiedBySingPass = '4',
}
